import { useState, useEffect } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "truestays_promo_bar_dismissed";
const PROMO_HEIGHT = "38px";

export default function PromoBar() {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let isDismissed = false;
    try { isDismissed = localStorage.getItem(STORAGE_KEY) === "1"; } catch (_) {}
    setDismissed(isDismissed);
    document.documentElement.style.setProperty("--ts-promo-height", isDismissed ? "0px" : PROMO_HEIGHT);
    return () => { document.documentElement.style.setProperty("--ts-promo-height", "0px"); };
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    document.documentElement.style.setProperty("--ts-promo-height", "0px");
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch (_) {}
  };

  if (dismissed) return null;

  const month = new Date().toLocaleString("en-GB", { month: "long" });

  return (
    <div className="ts-promo-bar" style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 250,
      height: PROMO_HEIGHT,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#112215",
      color: "#ffffff",
      padding: "0 44px",
      textAlign: "center",
      fontFamily: "'Inter', sans-serif",
      fontSize: 13.5,
      fontWeight: 500,
      lineHeight: 1.4,
    }}>
      <style>{`@media (max-width: 768px) { .ts-promo-bar { display: none !important; } :root { --ts-promo-height: 0px !important; } }`}</style>
      Free onboarding when you request a valuation in {month}
      <button
        onClick={handleDismiss}
        aria-label="Dismiss"
        style={{
          position: "absolute",
          right: 16,
          top: "50%",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
          opacity: 0.7,
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = "1"}
        onMouseLeave={e => e.currentTarget.style.opacity = "0.7"}
      >
        <X size={15} />
      </button>
    </div>
  );
}